import { LAYERTYPE, Layer, getWFS20Features, pageWFS20Features } from "./internal";
import { createFetchError } from "../../infra3d/utils/ajax";
/**
 * @class WFS20
 */
export class WFS20 extends Layer {
    constructor(scene, opt_options) {
        super(scene, opt_options);
        this.fetch_options = null;
        this.namespaces = "";
        this.version = "2.0.0";
        this.type = LAYERTYPE.WFS20;
        const options = opt_options || {};
        this.url = options.url || "";
        this.format = options.format || "geojson";
        this.fetch_options = options.fetch_options || null;
        this.namespaces = options.namespaces || "";
        this.version = options.version || "2.0.0";
    }
    /**
     * Loads all features within the extent
     * @param extent
     * @param srid
     */
    _loadFeatures_internal(extent, srid) {
        getWFS20Features(this.url, extent, srid, this.layername, (geojson) => {
            if (this.coordsdim == 2)
                Layer.geojsonRemoveZValues(geojson);
            this.addFeatures(geojson);
        }, (error) => {
            console.warn(error.message);
        }, this.format, this.version, this.fetch_options, this.namespaces);
    }
    /**
     * Gets all features on this layer
     * @param cbs
     * @param cbf
     * @param options
     * @private
     */
    _exportFeatures_internal(cbs, cbf, options) {
        const countonly = typeof options.countonly === "undefined" ? false : options.countonly;
        pageWFS20Features(this.url, this.layername, options.start || 0, options.limit || 10000, options.srid || "", countonly, (fc, counts) => {
            if (countonly) {
                cbs(counts);
            }
            else {
                cbs(fc);
            }
        }, (error) => {
            cbf(createFetchError(500, error.message));
        }, this.format, this.version, this.fetch_options);
    }
}
//# sourceMappingURL=wfs20.js.map